import { Button } from 'antd';
import * as React from 'react';
import StepperModel from '../models/StepperModel';
import { ArrowRightOutlined } from '@ant-design/icons';
import useFormBuilder from '../hooks/useFormBuilder';
import { useTranslation } from 'react-i18next';
import { SmallText } from './ui/Typography';

interface FCProps {
  loading?: boolean;
  onFormsValidationSuccess?: (
    formsData: Map<string, Record<string, any>>,
    runNextStep: () => void,
    toStep: (step: string) => void
  ) => Promise<void>;
  onFormsValidationFail?: () => void;
  buttonText?: string;
  icon?: React.ReactNode;
  position?: string;
  count?: number;
  maxCount?: number;
  label?: string;
  counterText?: string;
  disabled?: boolean;
  buttonId?: string;
  buttonGaEvent?: string;
}

const StepperFooter: React.FC<FCProps> = ({
  onFormsValidationSuccess,
  onFormsValidationFail,
  loading,
  buttonText,
  position = 'center',
  count,
  maxCount,
  label,
  counterText,
  disabled,
  icon,
  buttonId,
  buttonGaEvent,
}) => {
  const formManager = useFormBuilder();
  const { t } = useTranslation();

  return (
    <div
      className={`flex ${
        position === 'center'
          ? 'justify-start sm:justify-center'
          : `justify-${position}`
      }`}>
      <div className="flex flex-col items-center gap-2">
        <Button
          id={buttonId}
          data-ga-event={buttonGaEvent}
          loading={loading}
          disabled={loading || disabled}
          style={{ marginTop: '30px' }}
          onClick={async () => {
            let result = await formManager.validateAllForms();

            if (result === false) {
              onFormsValidationFail && onFormsValidationFail();
              return;
            }

            onFormsValidationSuccess &&
              (await onFormsValidationSuccess(
                result,
                async () => {
                  await StepperModel.firstNextStepFromPossibleNextSteps();
                  // scroll to top
                  window.scrollTo(0, 0);
                },
                (stepName) => {
                  StepperModel.changeStep(stepName);
                  // scroll to top
                  window.scrollTo(0, 0);
                }
              ));
          }}
          type="primary"
          htmlType="submit"
          icon={icon} // <-- use the icon prop here
        >
          {buttonText || t('Save and continue')}
        </Button>
        {(counterText ||
          (typeof count === 'number' &&
            typeof maxCount === 'number' &&
            label)) && (
          <SmallText style={{ color: 'rgba(0, 0, 0, 0.15)' }}>
            {counterText || `${count}/${maxCount} ${label} ${t('defined')}`}
          </SmallText>
        )}
      </div>
    </div>
  );
};

export default StepperFooter;
